import React from "react";
import Barcode from "../Barcode";
import { COMMAND_CODES } from "../../../constants/PickingConstant";

/**
 * The laminated card on the cart (HVC-58): one barcode per exception, so nothing on the scanner
 * ever has to be touched with a glove on. The values are the same constants every wave carries in
 * `commands`, so the card and the app cannot drift apart.
 */
export const COMMAND_CARD = [
  { key: "locationEmpty", nl: "VAK IS LEEG", en: "Location empty" },
  { key: "boxFull", nl: "DOOS VOL · VOLGENDE DOOS", en: "Box full · next box" },
  { key: "boxSmall", nl: "KLEINE DOOS GEPAKT", en: "Took a small box" },
  { key: "boxLarge", nl: "GROTE DOOS GEPAKT", en: "Took a large box" },
  { key: "confirmLine", nl: "REGEL BEVESTIGEN (GEEN VAK)", en: "Confirm line (no location)" },
  { key: "abortOrder", nl: "ORDER AFBREKEN", en: "Abort order" },
  { key: "pause", nl: "PAUZE", en: "Pause" },
];

const CommandCardSheet = React.forwardRef((props, ref) => (
  <div ref={ref} style={{ width: "190mm", fontFamily: "Arial, Helvetica, sans-serif", color: "#000", background: "#fff" }}>
    <div style={{ fontSize: "7mm", fontWeight: 800, marginBottom: "4mm" }}>Commando's · Commands</div>
    {COMMAND_CARD.map((command) => (
      <div
        key={command.key}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "0.4mm solid #000",
          padding: "3mm 0",
          pageBreakInside: "avoid",
        }}
      >
        <div>
          <div style={{ fontSize: "6mm", fontWeight: 800 }}>{command.nl}</div>
          <div style={{ fontSize: "4mm" }}>{command.en}</div>
        </div>
        <Barcode value={COMMAND_CODES[command.key]} moduleMm={0.45} heightMm={14} showValue fontSizeMm={2.6} />
      </div>
    ))}
  </div>
));

export default CommandCardSheet;
